/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Location_ReturnInputs */

const en_reference_location_return = /** @type {(inputs: Reference_Location_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Returns`)
};

/**
* | output |
* | --- |
* | "Returns" |
*
* @param {Reference_Location_ReturnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_location_return = /** @type {((inputs?: Reference_Location_ReturnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Location_ReturnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_location_return(inputs)
});